import jsonLogic from "json-logic-js";
import { filter, find, flatten, get, head, last, map, reject, size, split } from "lodash";

// Scan the context and return a list of items to exclude
const getExcludedItems = (ctx) => {
  const context = get(ctx, 'context', {});
  const excluded = flatten(map(context, item => get(item, 'discarded', [])));

  const mapped = map(excluded, item => {
    const id = split(item, '.');
    return size(id) === 2 ? { scope: head(id), name: last(id) } : { scope: 'question', name: head(id) };
  });

  return mapped;
};

/*
 * Create path of questions based on a graph and current context.
 *
 * First each block is tested to see if it's displayable or not. Then for each remaining blocks we perform the same test for each of its questions.
 *
 */
const createPath = (blocks, questions, graph, context, params) => {
  const blockList = map(graph, block => find(blocks, { name: block.name }));
  const blockFilteredList = filter(blockList, block => get(params, 'blockDisplayLogic', true) ? jsonLogic.apply(get(block, 'displayLogic', true), context) : true);
  const questionIdList = flatten(map(blockFilteredList, block => get(find(graph, { name: block.name }), 'values', [])));
  const questionList = map(questionIdList, name => find(questions, { name }));
  const questionFilteredList = filter(questionList, question => get(params, 'questionDisplayLogic', true) ? jsonLogic.apply(get(question, 'displayLogic', true), context) : true);

  const path = map(questionFilteredList, question => question.name);

  return path;
};

// Return path generated from the current state
export default (blocks, questions, graph, context, params) => {
  // First off get a list of items (blocks and questions) to exclude
  const excludedList = getExcludedItems(context);
  // console.log(excludedList);

  // First remove excluded blocks from the graph
  const blockFilteredGraph = reject(graph, item => find(excludedList, { scope: 'block', name: item.name }));
  // console.log(blockFilteredGraph);
  // Then do the same for the questions inside the remaining blocks
  const questionFilteredGraph = map(blockFilteredGraph, item => ({ name: item.name, values: reject(item.values, value => find(excludedList, { scope: 'question', name: value })) }));
  // console.log(questionFilteredGraph);

  // The path generated will not contain the excluded items
  const path = createPath(blocks, questions, questionFilteredGraph, context, params);
  // console.log(path);

  return path;
};
